// extracted by mini-css-extract-plugin
export default {"container":"CustomConfirmAlert_container__DUneb","container_titles":"CustomConfirmAlert_container_titles__KAis5","container_buttons":"CustomConfirmAlert_container_buttons__YDKVM"};